const model = {
    submitting: false,
    errors: null,
    categoryDetails: null,
    success: false,
    loading: false,
};

export default model;
